import { type FC } from "react";
import { Stack } from "@mui/material";
import { FilterProvider } from "@/partner/shared/components/Filter";
import { LinksFilter } from "./LinksFilter";
import { LinksList } from "./LinksList";
import { CreateLinkDialog } from "./CreateLinkDialog";
import { EditLinkDialog } from "./EditLinkDialog";
import { useSearchParams } from "react-router-dom";
import qs from "qs";

export const Links: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { tab, id: linkId } = qs.parse(searchParams.toString(), {
    ignoreQueryPrefix: true,
  }) as { tab?: string; id?: string };

  const handleEdit = (id: string) => {
    searchParams.set("tab", "edit");
    searchParams.set("id", id);
    setSearchParams(searchParams);
  };

  const handleCreate = () => {
    searchParams.set("tab", "create");
    setSearchParams(searchParams);
  };

  const handleCloseCreateDialog = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
  };

  const handleCloseEditDialog = () => {
    searchParams.delete("tab");
    searchParams.delete("id");
    setSearchParams(searchParams);
  };

  return (
    <FilterProvider>
      <Stack spacing={1}>
        <LinksFilter onCreateLink={handleCreate} />
        <LinksList onEditLink={handleEdit} />
      </Stack>

      <CreateLinkDialog
        open={tab === "create"}
        onClose={handleCloseCreateDialog}
        onCompleted={handleCloseCreateDialog}
      />

      <EditLinkDialog
        open={tab === "edit"}
        linkId={linkId ?? null}
        onClose={handleCloseEditDialog}
        onCompleted={handleCloseEditDialog}
      />
    </FilterProvider>
  );
};
